import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const ChangeValuesReservations = (state, action) => {
    console.log(action)
    return Object.assing({}, state, { state })
}

export const loadEvents = (state, action) => {
    let listEvents = JSON.parse(action.data)
    return Object.assign({}, state, { listEvents })
}

export const reservaEvent = (state, action) => {
    let listEvents = state.listEvents
    let currentEvent = listEvents[action.index]
    console.log(currentEvent)
    return Object.assign({}, state, { currentEvent })
}

export const reservateSeat = (state, action) => {
    let url = state.url;
    let CurrentSeat = JSON.parse(action.data);
    let data = {
        status: 'Pendiente',
        parent: CurrentSeat.id
    }
    axios.put(url + '/api/v1/reservations/availability/' + CurrentSeat.seats[0].id + '/pending/', data)
        .then(response => {
            // console.log(response)
            let data_add_cart = {
                id_availability: response.data.id,
                parent: response.data.parent,
                user: cookies.get('key'),
                type_seat: 'parent',
            }
            axios.post(url + '/api/v1/cart/add/', data_add_cart)
                .then(response => {
                    console.log(response.data)
                })
                .catch(err => {
                    console.log(err)
                })
        })
        .catch(err => {
            console.log(err)
        })
    return Object.assign({}, state, { CurrentSeat })
}

export const loadCurrentEvent = (state, action) => {
    let currentEvent = JSON.parse(action.event)
    return Object.assign({}, state, { currentEvent })
}


// WEBPACK FOOTER //
// ./src/Store/Reducers/ReservationsReducer.js